module.exports = __webpack_public_path__ + "media/images/background_onabet-dd054efe8190447f5862e670bbd58955.png";